export default __webpack_public_path__ + "img/mc_acc_opt_70_3x.e05c8b3b.png";